export const dateFormats = {
  examDate: 'YYYY-MM-DD',
};
